module.exports = __webpack_public_path__ + "img/monitoringdescription6.14539d12.png";